<template>
  <div>
    <!--  <div class="row">
      <div style="background-color:red" class="col-md-6 col-xs-12 p-md-5 pl-1 mx-5">HOLA</div>
    </div> -->
    <div class="row mx-0 mb-3">
      <div class="col-12" v-if="loading">
        <div v-if="loading" class="loading">Cargando Datos...</div>
      </div>
      <div class="col-12 px-4 px-sm-4 px-md-2" v-if="!loading">
        <span> {{ $tc("mi perro", 2) }} ({{ countDogs }}) </span>
        <button
          v-if="!editDog"
          class="btn btn-sm btn-outline-success mt-2 float-right pt-2 pb-2 btn-w"
          role="button"
          :class="{ 'btn-outline-warning': newDog }"
          @click.prevent="createNewDog"
        >
          {{ !newDog ? $t("agregar") : $t("cancelar") }}
          <i
            :class="{
              'fa fa-plus': !newDog,
              'fa fa-arrow-circle-left': newDog,
            }"
          ></i>
        </button>
        <button
          v-else
          class="btn btn-sm btn-outline-success mt-2 float-right pt-2 pb-2 btn-w"
          role="button"
          :class="{ 'btn-outline-warning': editDog }"
          @click.prevent="cancelEditUserDog"
        >
          {{ $t("cancelar") }}
          <i class="fa fa-arrow-circle-left"></i>
        </button>
      </div>
    </div>

    <!-- componente form edit perro -->
    <transition name="fade">
      <dog-new
        v-if="newDog"
        :editing="editDog"
        :dog="objDogEditing"
        :indexEdit="dogEditId"
        :lang="$i18n.locale"
        @emitEditingOrCreating="editingOrCreating"
      ></dog-new>
    </transition>

    <!-- componente form edit perro -->
    <transition name="fade">
 <!--      <dog-form
        v-if="editDog"
        :editing="editDog"
        :dog="objDogEditing"
        :indexEdit="dogEditId"
        :lang="$i18n.locale"
        @emitEditingOrCreating="editingOrCreating"
      ></dog-form> -->
      <dog-edit
      v-if="editDog"
      :dog="objDogEditing"
      :indexEdit="dogEditId"
      :lang="$i18n.locale"
      @emitEditingOrCreating="editingOrCreating" />
    </transition>

    <dog-list
      v-if="userData && !loading"
      :dogs="userData.dogs"
      :callEditDog="editUserDog"
      :callDeleteDog="deleteUserDog"
    ></dog-list>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import DogForm from "@/components/layouts/dogs/Dog-form.vue";
import DogEdit from "@/components/layouts/dogs/Dog-edit.vue";
import DogNew from "@/components/layouts/dogs/Dog-new.vue";
// import DogListCard from "@/components/layouts/dogs/Dog-list-card.vue";
import DogList from "@/components/layouts/dogs/Dog-list.vue";
import GeneralListType from "@/components/layouts/general/General-list-type";

export default {
  name: "dogs-main",
  components: {
    DogForm,  
    DogList,
    GeneralListType,
    DogNew,
    DogEdit
  },
  data() {
    return {
      newDog: false,
      editDog: false,
      objDogEditing: null,
      /*  indexEditing : -1, */
      dogEditId: -1,
    };
  },
  methods: {
    ...mapActions("notifier", ["default", "success", "error", "clear"]),
    ...mapActions("account", ["refreshUserData"]),
    createNewDog() {
      this.newDog = !this.newDog;
    },
    editingOrCreating(e) {
      this.editDog = false;
      this.newDog = false;
      this.dogEditId = -1;
    },
    editUserDog(e) {
      console.log("editando el perrete", e);
      if (this.editDog === true || this.newDog === true) {
        this.default("Ya estás actualizando un perro, debes cancelar antes..");
        return;
      }
      this.editDog = true;
      /* this.indexEditing = e.index; */
      this.dogEditId = e.objDog.id;
    },
    cancelEditUserDog() {
      this.editDog = false;
      this.objDogEditing = null;
    },
    deleteUserDog() {
      console.log("Pendiente.... Vas a eliminar un perrete");
    },
  },
  computed: {
    ...mapState("account", ["userData", "loading"]),
    countDogs() {
      //this.userData.dogs.length;
      return this.loading === false && this.userData != undefined
        ? this.userData.dogs.length
        : null;
    },
    btnText() {
      if (this.newDog === false && this.editDog === false) {
        return "agregar";
      } else if (this.newDog || this.editDog) {
        return "cancelar";
      }
    },
  },

  mounted() {
    this.refreshUserData();
  },
};
</script>
<style scoped>
>>> input,
>>> select {
  max-height: 35px;
  margin-left: 0px;
  background-color: #fff;
  border: 1px solid #ccc;
  padding-left: 5px;
}
>>> select {
  padding: 1px;
}
</style>
